export default "__VITE_ASSET__d0c72291__"